var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDimond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9992 41.6673L9.74925 22.6048C9.0555 21.7382 8.70758 21.3048 8.61592 20.784C8.52425 20.2632 8.69925 19.7361 9.04925 18.684L10.5992 14.0319C11.5159 11.2819 11.9742 9.9069 13.0659 9.12148C14.1576 8.33607 15.6076 8.33398 18.5055 8.33398H31.493C34.3909 8.33398 35.8409 8.33398 36.9305 9.12148C38.0242 9.9069 38.4826 11.2819 39.3993 14.0319L40.9492 18.684C41.2992 19.7361 41.4743 20.2611 41.3826 20.784C41.2888 21.3048 40.943 21.7382 40.2492 22.6048L24.9992 41.6673ZM24.9992 41.6673L32.2909 18.7507M24.9992 41.6673L17.7076 18.7507M32.2909 18.7507L40.6242 20.834M32.2909 18.7507L29.1659 10.4173M32.2909 18.7507H17.7076M17.7076 18.7507L20.8326 10.4173M17.7076 18.7507L9.37425 20.834",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDimond);
export default __webpack_public_path__ + "static/media/dimond.2944ffc56a485c8a576588a081476e5d.svg";
export { ForwardRef as ReactComponent };